import {APPS, SCOPES} from 'lib.common/dist/constantes';
const backEnd = process.env.REACT_APP_BACK_END;
const crm = process.env.REACT_APP_CRM;
export const baseName = process.env.REACT_APP_BASE_NAME || '';
export const urls = {
   backEnd,
   graph: backEnd + '/graphql',
   logIn: backEnd + '/login',
   logOut: backEnd + '/logout',
   verify: backEnd + '/verify'
};
export const urlsCrm = {
   crm,
   graph: crm + '/graphql'
};
export const apiRestUrl = process.env.REACT_APP_API_REST;
export const dsloginUrl = process.env.REACT_APP_API_DSLOGIN;
export const dsApiAuth = process.env.REACT_APP_API_AUTH || backEnd;
export const apiDsTienda = process.env.REACT_APP_API_DSTIENDA;
export const appName = 'DS-Key';
export const appId = APPS.key;
export const appScope = `${SCOPES.APP_INFO}.${appId}`;
export const callbackRoute = 'callback';
